<template>
  <div class="animated fadeIn">
    <b-form v-on:submit.prevent="onSubmit" @reset="setEmptyForm">
      <b-card :title="(!isEditMode ? '<b>Add New</b>' : '<b>Edit</b>') + ' Site'" sub-title="">
        <progress-loader ref="progress"></progress-loader>
        <b-form-row>
          <b-col md="12">
            <div v-if="errorMsg !== null" class="alert alert-danger" v-html="errorMsg"></div>
          </b-col>
          <b-col md="6">
            <b-form-group
                  label="Name" label-for="name"
                  label-class="font-weight-bold"
                  label-cols="3" :horizontal="true">
              <b-form-input
                    id="name"
                    type="text"
                    v-model="facility.name.value"/><span class="required-input-sign">*</span>
              <div v-if="facility.name.error !== null"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback d-block">{{facility.name.error}}</div>
            </b-form-group>
            <b-form-group
                  label="Desription" label-for="description"
                  label-class="font-weight-bold"
                  label-cols="3" :horizontal="true">
              <b-textarea
                    id="name"
                    :rows="3"
                    :max-rows="6"
                    v-model="facility.description.value"></b-textarea><span class="required-input-sign">*</span>
              <div v-if="facility.description.error !== null"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback d-block">{{facility.description.error}}</div>
            </b-form-group>
            <b-form-group
                  label="Address" label-for="address"
                  label-class="font-weight-bold"
                  label-cols="3" :horizontal="true">
              <b-textarea
                    id="name"
                    :rows="3"
                    :max-rows="6"
                    v-model="facility.address.value"></b-textarea><span class="required-input-sign">*</span>
              <div v-if="facility.address.error !== null"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback d-block">{{facility.address.error}}</div>
            </b-form-group>
            <b-form-group
                  v-show="this.isEditMode"
                  label="Availability" label-for="availability"
                  label-class="font-weight-bold"
                  label-cols="3" :horizontal="true">
              <b-row>
                <b-col sm="12">
                  <toggle-button
                        :color="`#3E975D`"
                        :sync="true"
                        v-model="facility.isAvailable.tempValue"/> <b class="padding-top-6">Available</b>
                  <div v-if="facility.isAvailable.error !== null"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        class="invalid-feedback d-block">{{facility.isAvailable.error}}</div>
                </b-col>
              </b-row>
            </b-form-group>
            <hr />
            <b-form-group
                  label="Icon" label-for="icon"
                  label-class="font-weight-bold"
                  label-cols="3" :horizontal="true">
                <b-form-file
                      id="inputIcon"
                      v-model="facility.icon.value"
                      :state="Boolean(facility.icon.value)"
                      placeholder="Choose an icon..."
                      accept="image/jpeg, image/png, image/gif"
                      @change="getImageURL('icon', null)"
                      ref="icon"></b-form-file>
                <div v-if="facility.icon.error !== null"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      class="invalid-feedback d-block">{{facility.icon.error}}</div>
              <b-form-row>
                <b-col lg="12 mt-2">
                  <b-img id="icon" src="#" class="img-fluid" fluid alt="" />
                </b-col>
              </b-form-row>
            </b-form-group>
          </b-col>
        </b-form-row>
        <div slot="footer">
          <b-row>
            <b-col md="6" lg="3" class="d-md-down-none">
              <b-button
                    size="md"
                    href='#/settings/sites'
                    variant="light"
                  class="btn-pill">
                <i class="fa fa-arrow-left"></i> Back
              </b-button>
            </b-col>
            <b-col md="6" lg="3" class="text-right">
              <b-button
                    type="reset"
                    size="md"
                    variant="danger"
                    class="btn-pill">
                <i class="fa fa-ban"></i> Reset
              </b-button> 
              <b-button
                    type="submit"
                    size="md"
                    variant="primary"
                    class="btn-pill">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import progressLoader from '@/views/components/progressLoader'
import VueTimepicker from 'vue2-timepicker'
import ToggleButton from 'vue-js-toggle-button'

Vue.use(VueTimepicker)
Vue.use(ToggleButton)

export default {
  name: 'facilityCreate',
  components: {
    axios,
    progressLoader,
    VueTimepicker
  },
  data () {
    return {
      isEditMode: this.$route.params.id !== undefined,
      apiUrl: window.AppConfig.apiUrl + 'site',
      apiUrlGetDetail: window.AppConfig.apiUrl + 'site',
      // model form
      showLoader: false,
      errorMsg: null,
      facility: {
        uuid: {
          rule: 'editable',
          value: this.$route.params.id
        },
        name: {
          rule: 'required editable',
          value: null,
          error: null
        },
        description: {
          rule: 'required editable',
          value: null,
          error: null
        },
        address: {
          rule: 'required editable',
          value: null,
          error: null
        },
        icon: {
          rule: 'required editable',
          value: null,
          error: null
        },
        isAvailable: {
          rule: 'required editable',
          value: 0,
          tempValue: true,
          error: null
        }
      }
    }
  },
  mounted () {
    this.setEmptyForm()
    if (this.isEditMode) {
      this.getDetailInfo()
    }
  },
  methods: {
    onSubmit () {
      // init var
      this.errorMsg = null
      let hasError = false
      let obj = Object.keys(this.facility)
      this.facility.isAvailable.value = this.facility.isAvailable.tempValue ? 1 : 0

      // validating
      for (let i = 0; i < obj.length; i++) {
        let rule = this.facility[obj[i]].rule
        if (
          (
            rule.indexOf('required') !== -1 ||
            (
              this.isEditMode &&
              rule.indexOf('editable') !== -1 &&
              rule.indexOf('required') !== -1
            )
          ) &&
          (this.facility[obj[i]].value === null || this.facility[obj[i]].value === '' || this.facility[obj[i]].value.HH === null)
        ) {
          this.facility[obj[i]].error = 'This field is required'
          hasError = true
        } else {
          this.facility[Object.keys(this.facility)[i]].error = null
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar()
        this.$alertify.error('Failed! Please complete the message and submit again.')
        return false
      }

      // collect data
      let formData = new FormData()
      for (let i = 0; i < Object.keys(this.facility).length; i++) {
        let key = Object.keys(this.facility)[i]
        if (this.facility[key].value !== null && key !== 'uuid') {
          if (key.indexOf('Time') >= 0) {
            formData.append(key, this.facility[key].value.HH + ':' + this.facility[key].value.mm)
          } else if (key.indexOf('icon') >= 0) {
            if (typeof this.facility[key].value !== 'string') {
              formData.append(key, this.facility[key].value)
            }
          } else {
            formData.append(key, this.facility[key].value)
          }
        }
      }
      var self = this
      self.$refs.progress.activateProgressBar()
      // submit data
      if (!this.isEditMode) {
        // POST
        axios.post(this.apiUrl, formData)
          .then(response => {
            self.$refs.progress.deactivateProgressBar()
            self.setEmptyForm()
            window.setTimeout(() => {
              self.$alertify.success('Site has been added!')
            }, 2000)
            window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
          })
          .catch(error => {
            self.doCollectErrMessage(error)
          })
      } else {
        // PATCH
        self.$refs.progress.deactivateProgressBar()
        axios.patch(this.apiUrl + '/' + this.facility.uuid.value, formData)
          .then(response => {
            // self.setEmptyForm()
            window.setTimeout(() => {
              self.$alertify.success('Site has been updated!')
            }, 2000)
            window.location.href = document.URL.replace('/edit', '')
          })
          .catch(error => {
            self.doCollectErrMessage(error)
          })
      }
    },

    getDetailInfo () {
      axios.get(this.apiUrlGetDetail + '/' + this.$route.params.id)
        .then(response => {
          this.facility.uuid.value = response.data.uuid
          this.facility.name.value = response.data.name
          this.facility.description.value = response.data.description
          this.facility.address.value = response.data.address
          this.facility.icon.value = response.data.icon
          this.getImageURL('icon', response.data.icon)
          this.facility.isAvailable.tempValue = !!response.data.isAvailable
          this.facility.isAvailable.value = response.data.isAvailable
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          window.history.back()
        })
    },
    getImageURL (imgId, optionalUrl) {
      let input = null
      let objImg = document.getElementById(imgId)
      input = document.getElementById('inputIcon')

      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          objImg.setAttribute('src', e.target.result)
        }
        reader.readAsDataURL(input.files[0])
      } else {
        objImg.setAttribute('src', optionalUrl)
      }
    },

    setEmptyForm () {
      this.facility.uuid.value = null
      this.facility.name.value = null
      this.facility.description.value = null
      this.facility.address.value = null
      this.facility.icon.value = null
      this.$refs.icon.reset()
      this.getImageURL('icon', null)
      this.facility.isAvailable.tempValue = true
      this.facility.isAvailable.value = 1
    },

    doCollectErrMessage (error) {
      // this.$refs.progress.deactivateProgressBar()
      this.$alertify.error('Failed! Please complete the message and submit again.')
      this.$store.dispatch('errorMessage', error)
        .then(errMsg => {
          this.errorMsg = errMsg
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/settings/facility/Form.vue